import { ActionIcon, Text } from "@mantine/core";
import React, { useState } from "react";
import classes from "./monitoringQueueActions.module.scss";
import IconRefresh from "@tabler/icons-react/dist/esm/icons/IconRefresh.mjs";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const MonitoringQueueActions = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await queryClient.invalidateQueries(["get-monitoring-queue"]);
    setIsRefreshing(false);
  };

  return (
    <div className={classes["title-grid"]}>
      <div />
      <Text size="md" weight={700} m="sm">
        {t("pageHeaders.monitoringQueue")}
      </Text>
      <div className={classes["action-refresh-icon"]}>
        <ActionIcon
          variant="subtle"
          onClick={handleRefresh}
          disabled={isRefreshing}
          aria-label="Refresh"
        >
          <IconRefresh size={26} className={isRefreshing ? classes.spin : ""} />
        </ActionIcon>
      </div>
    </div>
  );
};

export default MonitoringQueueActions;
